<style>
  .flames {
    background-image: url(/img/flames-small.gif);
    background-position-x: -2rem;
    background-position-y: -7rem;
    color: transparent;
    -moz-background-clip: text;
    -webkit-background-clip: text;
  }
</style>

<span class="flames">
  <slot></slot>
</span>